import React, { useState, useEffect } from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import supabase from '../supabase';

export default function Thoughts() {
  const [thoughts, setThoughts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchThoughts() {
      const { data, error } = await supabase
        .from('thoughts')
        .select('*')
        .order('created_at', { ascending: false });
      if (error) { setError(error.message); setLoading(false); return; }
      setThoughts(data || []);
      setLoading(false);
    }
    fetchThoughts();
  }, []);

  if (loading) return <div className="text-center mt-5"><Spinner animation="border" /></div>;

  return (
    <div>
      <div className="page-header">
        <h1>Thoughts</h1>
        <p>{thoughts.length} entries</p>
      </div>

      {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}

      {thoughts.length === 0 ? (
        <div className="d-card"><p style={{ color: 'var(--text-muted)', margin: 0 }}>No thoughts yet.</p></div>
      ) : (
        <div style={{ maxWidth: 680 }}>
          {thoughts.map(t => (
            <div key={t.id} className="thought-card">
              <div className="thought-body">{t.content || t.thought || t.body || t.text || '(empty)'}</div>
              <div className="thought-time">
                {t.created_at ? new Date(t.created_at).toLocaleString() : ''}
                {t.mood && <span style={{ marginLeft: 12 }} className="pill pill-accent">{t.mood}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
